import { isWeb } from '@gluestack-ui/nativewind-utils/IsWeb';

/**
 * Returns React Native text props (numberOfLines, ellipsizeMode) conditionally based on platform.
 * On web, these props are not valid DOM attributes and will cause React warnings.
 */
export function getNativeTextProps({
  numberOfLines = 1,
  ellipsizeMode = 'tail',
}: {
  numberOfLines?: number;
  ellipsizeMode?: 'head' | 'middle' | 'tail' | 'clip';
} = {}) {
  if (isWeb) {
    return undefined;
  }

  return {
    numberOfLines,
    ellipsizeMode,
  };
}
